import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      get_creatives_link: {
        list: {
          header: 'LIST_HEADER',
          preview_button: 'PREVIEW_BTN',
          view_code_button: 'VIEW_CODE_BTN',
          copy_code_button: 'COPY_CODE_BTN',
          download_image_button: 'DOWNLOAD_IMAGE_BTN',
          back: 'BACK',
          modal_window: {
            creative_code: 'CREATIVE_CODE',
            button_cancel: 'BUTTON_CANCEL',
            button_copy: 'BUTTON_COPY',
          },
        },
      },
    },
  }));
}
